import React from "react";
import { Linkedin } from "lucide-react";

export const LinkedInFollowButton = () => {
  return (
    <section
      data-testid="linkedin-follow-section"
      className="w-full flex justify-center px-4 sm:px-6 lg:px-8 pb-16 bg-white"
    >
      <a
        href="https://www.linkedin.com/company/109300155/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="linkedin-follow-button"
        className="inline-flex items-center gap-3 rounded-full bg-[#0A66C2] px-7 py-3 text-base font-semibold text-white shadow-md transition-all duration-300 hover:bg-[#004182] hover:shadow-xl hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-[#0A66C2]/30"
      >
        <Linkedin className="w-5 h-5" />
        <span>Follow us on LinkedIn</span>
      </a>
    </section>
  );
};
